import { USDC_ADDRESSES, USDC_PERP_ADDRESS_HYPERCORE } from '../constants/addresses';
import { CHAIN_IDS, HYPERCORE_CHAIN_ID } from '../constants/chain';
import type { TokenBase, TokenSearchResponse, TokensResponse } from './0x/token-registry.types';
import { canonicalSolanaMint } from './multichain';

// Join the search results from multiple pages into a single array of unique tokens
export const joinSearchResults = (
  searchResultsPaginated: (TokensResponse | TokenSearchResponse)[],
): TokenBase[] => {
  const map = new Map<string, TokenBase>();

  searchResultsPaginated.forEach((page) => {
    if ('data' in page && page.data) {
      page.data.forEach((token) => {
        map.set(`${token.chainId}-${token.address}`, token);
      });
    }
  });

  return Array.from(map.values());
};
export const makeImageProxyUrl = (chainId: number, address: string, fullSize = false) => {
  // The image proxy has no HyperCore entries; USDC_PERP is drawn as HyperEVM USDC.
  const url =
    chainId === HYPERCORE_CHAIN_ID && address === USDC_PERP_ADDRESS_HYPERCORE
      ? `https://matcha-image-proxy.api.0x.org/images/${CHAIN_IDS.HYPEREVM}/${USDC_ADDRESSES[CHAIN_IDS.HYPEREVM]}`
      : `https://matcha-image-proxy.api.0x.org/images/${chainId}/${canonicalSolanaMint(address)}`;
  if (fullSize) {
    return `${url}/original`;
  }
  return url;
};
